import { Link } from "react-router-dom";
import dylanImage from "../assets/dylantraced.png";

export default function Home() {
  const year = new Date().getFullYear();

  return (
    <div className="relative flex flex-col md:flex-row md:h-screen min-h-screen bg-white text-black">

      {/* Left — text */}
      <div className="flex-1 flex flex-col justify-center px-8 sm:px-12 lg:px-20 pt-24 pb-10 md:py-0">
        <p className="text-[10px] tracking-[0.22em] uppercase text-gray-400 font-medium mb-4">
          Social Entrepreneur · Technologist
        </p>

        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.05] tracking-tight mb-5 whitespace-nowrap">
          Dylan Zajac
        </h1>

        <p className="text-base text-gray-500 leading-relaxed max-w-sm mb-8">
          Building a nationwide movement that uses technology to unlock
          opportunity and help thousands pursue their dreams.
        </p>

        <div className="flex gap-3 flex-wrap">
          <Link
            to="/about"
            className="px-6 py-2.5 bg-black text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors duration-200"
          >
            About Me
          </Link>
          <Link
            to="/contact"
            className="px-6 py-2.5 border border-gray-200 text-sm font-medium rounded-lg hover:border-gray-400 transition-colors duration-200"
          >
            Get in Touch
          </Link>
        </div>

      </div>

      {/* Mobile portrait */}
      <div className="flex md:hidden justify-center px-8 pb-12">
        <img
          src={dylanImage}
          alt="Dylan Zajac"
          className="max-h-[52vh] w-auto object-contain pointer-events-none select-none"
        />
      </div>

      {/* Desktop portrait — pinned to bottom right */}
      <div className="hidden md:flex flex-col justify-end items-center flex-shrink-0 w-[44%] xl:w-[40%]">
        <img
          src={dylanImage}
          alt="Dylan Zajac"
          className="max-h-[90vh] w-auto object-contain object-bottom pointer-events-none select-none"
        />
      </div>

      {/* Footer */}
      <p className="absolute bottom-3 left-1/2 -translate-x-1/2 text-[10px] text-gray-300 whitespace-nowrap pointer-events-none hidden md:block">
        © {year} Dylan Zajac. All rights reserved.
      </p>
      <p className="text-[10px] text-gray-300 text-center pb-6 md:hidden">
        © {year} Dylan Zajac. All rights reserved.
      </p>
    </div>
  );
}
